module.exports = __webpack_public_path__ + "assets/img/hbjh2.9dda114e.png";